import React from 'react';
import { Typography, Grid } from '@mui/material';
import { styled } from '@mui/system';
import ItemSelectionCard from './ItemSelectionCard';

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  textAlign: 'center',
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%'
  }
}));

const StyledNote = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: 'center',
  alignSelf: 'center',
  marginTop: theme.spacing(3),
  width: '264px'
}));

const CheckItemModalChild = () => {
  const selectionOptions = [
    {
      title: 'Detailed Queries',
      description:
        'Let us walk you through each of the updated queries that need adjusted before you run the cycle.',
      buttonText: 'Walk me through',
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/48e4986368e05579cbca838a4a68650c6fd32835b5f8cddf22407085077aa813?placeholderIfAbsent=true&apiKey=a89de26992d44b12b08c0708d35bc803'
    },
    {
      title: 'Master Data Table',
      description: 'Want to go at your own pace within data table?',
      buttonText: 'Fill in as I go',
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/068c276650377c584648919cd8d63136ca5b0ae14ff57260bd443dbca95e8dc3?placeholderIfAbsent=true&apiKey=a89de26992d44b12b08c0708d35bc803'
    }
  ];

  return (
    <div>
      <StyledTitle variant="h5" component="h5">
        How would you like to go through the missing data?
      </StyledTitle>
      <Grid container spacing={2}>
        {selectionOptions.map((option, index) => (
          <Grid item xs={12} md={6} key={`${index + 1}`}>
            <ItemSelectionCard {...option} />
          </Grid>
        ))}
      </Grid>
      <StyledNote variant="body2">
        You will be able to review between detailed queries and master data table regardless.
      </StyledNote>
    </div>
  );
};

export default CheckItemModalChild;
